// Copyright (c) Docugami, Inc. All rights reserved.

import { primaryTheme, themeBlue } from "components/shell/presentation/AppStyles";
import { DgIconButton } from "components/shell/utils/DgIconButton";
import { ReportViewMode } from "hooks/navigationService";
import { AutomationId } from "utils/Automation";
import styled from 'styled-components';
import { TooltipHost } from "@fluentui/react";
import { ReportViewModeDescription } from "hooks/ReportViewModes";

const ViewButton = styled(DgIconButton) <{ selected?: boolean }>`
    i {
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${props => props.selected ? themeBlue : ''};
    }
`

const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
`

interface ReportViewModeSwitcherProps {
    viewDescriptions: ReportViewModeDescription[];
    currentMode: ReportViewMode;
    onViewChange: (viewMode: ReportViewMode) => void;
    className?: string;
}

export const ReportViewModeSwitcher = ({ viewDescriptions, currentMode, onViewChange, className }: ReportViewModeSwitcherProps) => {
    return (
        <ButtonGroup
            data-automation-id={AutomationId.WorkPathViewSwitcher}
            className={className}>
            {
                viewDescriptions.map(viewDescription => {
                    const selected = viewDescription.viewMode === currentMode;
                    return (
                        <TooltipHost key={viewDescription.viewMode} content={viewDescription.tooltip}>
                            <ViewButton
                                key={viewDescription.viewMode}
                                iconName={viewDescription.iconName}
                                selected={selected}
                                height={36}
                                width={35}
                                color={selected ? primaryTheme.palette.white : primaryTheme.palette.black}
                                onClick={() => onViewChange(viewDescription.viewMode)}
                                disabled={viewDescription.disabled} />
                        </TooltipHost>
                    )
                })
            }
        </ButtonGroup>
    );
}
